/**
 *
 * @param {string | number} id
 * @returns string
 */
export const cancelReason = (id) => {
  const strId = String(id);
  const reasonMap = {
    "1": "Hata/sorun Bildirimi",
    "2": "Daha Önce İletilmiş Fikir",
    "3": "Fikir Platformu Kapsamında Değerlendirilmemektedir",
    "4": "Projelendirilen/Mevcut Uygulama",
    "5": "Product Board Kararı",
    "6": "Fikir Sahibi Çekildi",
    "7": "Fayda-Maliyet Oranı Düşük",
    "8": "Teknik/İşlevsel/Süreçsel Olarak Uygun Değil",
  };
  return reasonMap[strId] || "";
};
